import React, { useState, useEffect } from 'react';
import classes from '../Preguntas.css';

export default function PreguntaMenu({
  PreguntasOpciones,
  valorDefault = '',
  numeroPregunta,
  onChangeRespuesta,
  onElegir,
  esObligatoria
}) {
  const [selectedValue, setSelectedValue] = useState(valorDefault);

  // 🔁 Sincronizar si valorDefault cambia
  useEffect(() => {
    if (valorDefault !== selectedValue) {
      setSelectedValue(valorDefault);
    }
  }, [valorDefault]);

  const elegir = (opcion) => {
    setSelectedValue(opcion.id);
    onElegir?.();
  };

  useEffect(() => {
    const tieneContenido = selectedValue !== '';
    const opcionSeleccionada = PreguntasOpciones.find((opcion) => opcion.id === parseInt(selectedValue));
    const contenido = opcionSeleccionada ? [opcionSeleccionada.id, opcionSeleccionada.opcion] : null;

    const respuesta = {
      numeroPregunta,
      tieneContenido,
      contenido,
      esObligatoria
    };

    onChangeRespuesta(respuesta);
  }, [selectedValue, PreguntasOpciones]);

  return (
    <div className={classes.sino}>
      {PreguntasOpciones.map((opcion) => {
        const seleccionada = parseInt(selectedValue) === opcion.id;
        return (
          <button
            key={opcion.id}
            type="button"
            className={seleccionada ? classes.sel : ''}
            aria-pressed={seleccionada}
            onClick={() => elegir(opcion)}
          >
            {String(opcion.opcion ?? '').trim()}
          </button>
        );
      })}
    </div>
  );
}
